import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class HeaderScriptInjectorService {
    constructor(@Inject(DOCUMENT) private dom: Document) {}

    injectScripts(): void {
        if (!this.dom.getElementById('header-script-1')) {
            const s: HTMLScriptElement = this.dom.createElement('script');
            s.id = 'Header-Script-1';
            s.type = 'module';
            s.src = environment.bahfV6Webcomponent + 'bahf-webcomponents.esm.js';
            s.text = ``;

            this.dom.head.appendChild(s);
        }
        if (!this.dom.getElementById('header-script-2')) {
            const s2: HTMLScriptElement = this.dom.createElement('script');
            s2.id = 'Header-Script-2';
            s2.type = 'text/javascript';
            s2.src = environment.bahfV6Webcomponent + 'bahf-webcomponents.js';
            s2.text = ``;
            s2.noModule = true;

            this.dom.head.appendChild(s2);
        }
    }
}
